import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
	selector: 'app-server-alert-dialog',
	styles: [
		`
			.msg-line:first-of-type {
				margin: 0 0 12px;
			}
		`,
	],
	template: `
		<app-dialog
			modalTitle="Atenção"
			titleButton="Ok"
			[secButton]="false"
			[asAlert]="true"
			(dialogClose)="dialogRef.close()"
			(dialogSave)="dialogRef.close()"
		>
			<div class="fs-xxxs lh-md">
				<ng-container *ngIf="data?.message?.length; else defaultMsg">
					<p class="msg-line" *ngFor="let m of data.message">{{ m }}</p>
				</ng-container>
				<ng-template #defaultMsg>
					<p>
						Desculpe-nos pelo transtorno. Ocorreu um erro técnico que está
						impedindo de acessar ao sistema. Nossa equipe já foi notificada e
						está trabalhando para resolver o problema o mais rápido possível.
						Por favor, tente novamente mais tarde ou entre em contato conosco
						para mais informações. Agradecemos a sua compreensão e paciência.
					</p>
				</ng-template>
			</div>
		</app-dialog>
	`,
})
export class ServerAlertDialogComponent {
	constructor(
		public dialogRef: MatDialogRef<ServerAlertDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: { message?: string[] },
	) {}
}
